import OrganizationCreatePage from "@/features/organization/pages/OrganizationCreate";

const OrganizationCreate = () => {
  return <OrganizationCreatePage />;
};

export default OrganizationCreate;
